<template>
    <th colspan="1" rowspan="1" @click="sortValue()">
      <div class="vs-table-text">
        <slot></slot>
        <span v-if="isColumnSelectedForSort && currentSort != 0" class="sort-th">
          <vs-icon
            :icon="currentSort == 1 ? 'expand_less' : 'expand_more'"
            class="th-sort-icon">
          </vs-icon>
        </span>
      </div>
    </th>
  </template>
  
<script>
export default {
  name: 'VsTh',
  props: {
    sortKey: {
      default: null,
      type: String
    }
  },
  data: () => ({
    currentSort: 0,
    sortStatuses: [null, 'asc', 'desc']
  }),
  computed: {
    isColumnSelectedForSort () {
      return this.sortKey && this.$parent.currentSortKey === this.sortKey
    }
  },
  methods: {
    sortValue () {
      if (this.sortKey) {
        this.currentSort = this.currentSort !== 2 ? this.currentSort + 1 : 0
        this.$parent.sort(this.sortKey, this.sortStatuses[this.currentSort])
      }
    }
  }
}
</script>
  